module.exports = __webpack_public_path__ + "img/gb9113_20_d.prt.deea66b8.jpg";